//Includes polyfill
if (!String.prototype.includes) {
    String.prototype.includes = function(search, start) {
        'use strict';
        if (search instanceof RegExp) {
            throw TypeError('first argument must not be a RegExp');
        }
        if (start === undefined) { start = 0; }
        return this.indexOf(search, start) !== -1;
    };
}

if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = Array.prototype.forEach;
}

Element.prototype.remove || (Element.prototype.remove = function() {
	if (this.parentNode!=null) this.parentNode.removeChild(this);
});

const startBusinessForm = `
    <div class="form__col left-col">
        <div class="form__col__block">
            <h2 class="heading--medium">${rvo_obj.translations.title_about_business}</h2>
            <div class="input-group" id="business_name">
                <input class="input required" name="business_name" type="text" required="required" placeholder="${rvo_obj.translations.placeholder_business_name} *">
                <span class="error-message">${rvo_obj.translations.error_business_name}</span>
            </div>
            <div class="input-group">
                <input class="input" name="website" type="text" placeholder="${rvo_obj.translations.placeholder_website}">
            </div>
            <div class="input-group" id="sector">
                <input class="input required" name="sector" type="text" required="required" placeholder="${rvo_obj.translations.placeholder_sector} *">
                <span class="error-message">${rvo_obj.translations.error_sector}</span>
            </div>
            <div class="input-group" id="fileinput">
                <input class="input file-input required" id="file-input" name="file" required="required" type="file">
                <button type="button" class="input custom-file-input">
                    <span>${rvo_obj.translations.text_upload}</span>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 47 47"><path data-name="Path 7" d="M31 0a1 1 0 000 2h12.59l-25.8 25.79a1 1 0 000 1.41.982.982 0 00.71.29 1.024 1.024 0 00.71-.29L45 3.41V16a1 1 0 002 0V0z" fill="#ff6833"/><path data-name="Path 8" d="M41 27a1 1 0 00-1 1v14a3.009 3.009 0 01-3 3H5a3.009 3.009 0 01-3-3V10a3.009 3.009 0 013-3h13a1 1 0 000-2H5a5 5 0 00-5 5v32a5 5 0 005 5h32a5 5 0 005-5V28a1 1 0 00-1-1z" fill="#ff6833"/></svg>
                </button>
                <div class="custom-file">
                    <span class="file-name paragraph--regular">${rvo_obj.translations.no_file}</span>
                    <button class="delete_file" type="button">
                        <img src="../wp-content/themes/rvon/images/icons/delete_icon.svg" alt="${rvo_obj.translations.alt_delete_file}">
                    </button>
                </div>
                <span class="error-message">${rvo_obj.translations.no_file_error}</span>
            </div>
        </div>
        <div class="form__col__block">
            <h2 class="heading--medium">${rvo_obj.translations.title_get_known}</h2>
            <div class="input-group" id="name">
                <input class="input required" name="name" type="text" required="required" placeholder="${rvo_obj.translations.placeholder_name} *">
                <span class="error-message">${rvo_obj.translations.error_name}</span>
            </div>
            <div class="input-group">
                <select class="input select" name="nationality">
                    <option value="">${rvo_obj.translations.placeholder_nationality}</option>
                    <option value="non-EU/EEA or Swiss">non-EU/EEA or Swiss</option>
                    <option value="EU">EU</option>
                </select>
                <span class="error-message">${rvo_obj.translations.error_nationality}</span>
            </div>
            <div class="input-group" id="email">
                <input class="input required" name="email" type="email" required="required" placeholder="Business Email *">
                <span class="error-message">${rvo_obj.translations.error_email}</span>
            </div>
            <div class="input-group">
                <input class="input linkedin-input" type="url" name="linkedin" pattern="https://.*" placeholder="LinkedIn">
                <svg data-name="Group 3" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 46.06 46.05"><g data-name="Group 2" fill="#ff6833"><path data-name="Path 13" d="M46.06 23.03v.03l-.15 9.66A13.329 13.329 0 0132.73 45.9l-9.7.15H23l-9.66-.15A13.329 13.329 0 01.16 32.72L0 23.03V23l.15-9.66A13.338 13.338 0 0113.33.15l9.7-.15h.03l9.66.15A13.329 13.329 0 0145.9 13.33zm-4.29 0l-.15-9.63a9.062 9.062 0 00-8.96-8.96l-9.63-.15-9.63.15a9.076 9.076 0 00-8.96 8.96l-.15 9.63.15 9.63a9.062 9.062 0 008.96 8.96l9.63.15 9.63-.15a9.062 9.062 0 008.96-8.96z"/><path data-name="Path 14" d="M34.4 15.53c1.55 1.58 1.53 3.92 1.5 6.63 0 .41-.01.85-.01 1.29v10.57a1.505 1.505 0 11-3.01 0V23.45c0-.46 0-.91.01-1.33.03-2.12.05-3.79-.63-4.47-.46-.47-1.46-.7-2.98-.7-1.86 0-4.18 1.75-5.01 2.89l-.02 13.63a1.51 1.51 0 01-3.02 0l.02-13.7a1.526 1.526 0 01-.03-.3V15.1a1.51 1.51 0 013.02 0v.69a.906.906 0 01.16-.11 8.978 8.978 0 014.88-1.73c2.42-.03 4.05.48 5.12 1.58z"/><path data-name="Path 15" d="M12.54 13.59a1.515 1.515 0 00-1.51 1.51v18.94a1.51 1.51 0 003.02 0V15.09a1.5 1.5 0 00-1.51-1.5z"/></g><path data-name="Path 16" d="M12.53 9.38a1.705 1.705 0 101.7 1.72v-.02a1.686 1.686 0 00-1.7-1.7z" fill="#ff6833"/></svg>
            </div>
        </div>
    </div>
    <div class="form__col right-col">
        <div class="form__col__block" id="checkboxes">
            <h2 class="heading--medium">${rvo_obj.translations.title_experience_nl}</h2>
            <div class="checkbox">
                <input class="input checkbox_input" name="checkbox[]" id="curious" value="Curious about the Netherlands" type="checkbox">
                <label for="curious" class="checkbox__label">${rvo_obj.translations.checkbox_curious_about}</label>
            </div>
            <div class="checkbox">
                <input class="input checkbox_input" name="checkbox[]" id="enthusiastic" value="Enthusiastic visitor" type="checkbox">
                <label for="enthusiastic" class="checkbox__label">${rvo_obj.translations.checkbox_enthusiastic_visitor}</label>
            </div>
            <div class="checkbox">
                <input class="input checkbox_input" name="checkbox[]" id="trade" value="Experience with Dutch trade partners or customers" type="checkbox">
                <label for="trade" class="checkbox__label">${rvo_obj.translations.checkbox_experience_partners}</label>
            </div>
            <div class="checkbox">
                <input class="input checkbox_input" name="checkbox[]" id="study" value="Study followed in the Netherlands" type="checkbox">
                <label for="study" class="checkbox__label">${rvo_obj.translations.checkbox_study_nl}</label>
            </div>
            <div class="checkbox">
                <input class="input checkbox_input" name="checkbox[]" id="work" value="Work experience in the Netherlands" type="checkbox">
                <label for="work" class="checkbox__label">${rvo_obj.translations.checkbox_work_experience}</label>
            </div>
            <span class="error-message checkbox-error">${rvo_obj.translations.error_checkbox}</span>
        </div>
        <div class="form__col__block">
            <h2 class="heading--medium">${rvo_obj.translations.title_textarea}?</h2>
            <textarea class="input" name="info" cols="30" rows="10"></textarea>
            <div class="send-error">
                <span></span>
            </div>
            <div class="contact-submit">
                <button class="btn-primary submit-form" type="submit" id="submit_form">
                    ${rvo_obj.translations.text_send}
                </button>
                <div class="loader">
                    <svg xmlns="http://www.w3.org/2000/svg" width="50" height="30" viewBox="0 0 120 30" fill="#ff6833">
                        <circle cx="15" cy="15" r="9.32367">
                            <animate attributeName="r" from="15" to="15" begin="0s" dur="0.8s" values="15;9;15" calcMode="linear" repeatCount="indefinite"/>
                            <animate attributeName="fill-opacity" from="1" to="1" begin="0s" dur="0.8s" values="1;.5;1" calcMode="linear" repeatCount="indefinite"/>
                        </circle>
                        <circle cx="60" cy="15" r="14.6763" fill-opacity="0.3">
                            <animate attributeName="r" from="9" to="9" begin="0s" dur="0.8s" values="9;15;9" calcMode="linear" repeatCount="indefinite"/>
                            <animate attributeName="fill-opacity" from="0.5" to="0.5" begin="0s" dur="0.8s" values=".5;1;.5" calcMode="linear" repeatCount="indefinite"/>
                        </circle>
                        <circle cx="105" cy="15" r="9.32367">
                            <animate attributeName="r" from="15" to="15" begin="0s" dur="0.8s" values="15;9;15" calcMode="linear" repeatCount="indefinite"/>
                            <animate attributeName="fill-opacity" from="1" to="1" begin="0s" dur="0.8s" values="1;.5;1" calcMode="linear" repeatCount="indefinite"/>
                        </circle>
                    </svg>
                    <span>${rvo_obj.translations.text_loader}</span>
                </div>
            </div>
        </div>
    </div>
`;
const jobForm = `
    <div class="form-link">
        <p class="heading--small">${rvo_obj.working_in_nl_data.text}</p>
        <a href="${rvo_obj.working_in_nl_data.button_url}" class="btn-primary">
            ${rvo_obj.working_in_nl_data.button_text}
        </a>
    </div>
`;
const studyingForm = `
    <div class="form-link">
        <p class="heading--small">${rvo_obj.studying_in_nl_data.text}</p>
        <a href="${rvo_obj.studying_in_nl_data.button_url}" class="btn-primary">
            ${rvo_obj.studying_in_nl_data.button_text}
        </a>
    </div>
`;
const otherForm = `
    <div class="form__col left-col">
        <div class="form__col_block basic-form">
            <h2 class="heading--medium">${rvo_obj.translations.title_textarea_other}</h2>
            <div class="input-group">
                <textarea class="input required other-form-textarea" name="info" cols="30" rows="13"></textarea>
                <span class="error-message">${rvo_obj.translations.error_textarea}</span>
            </div>
        </div>
    </div>
    <div class="form__col right-col">
        <div class="form__col__block">
            <h2 class="heading--medium">${rvo_obj.translations.title_form_other}</h2>
            <div class="input-group" id="name">
                <input class="input required" name="name" type="text" required="required" placeholder="${rvo_obj.translations.placeholder_name} *">
                <span class="error-message">${rvo_obj.translations.error_name}</span>
            </div>
            <div class="input-group">
                <select class="input select" name="nationality">
                    <option value="">${rvo_obj.translations.placeholder_nationality}</option>
                    <option value="non-EU/EEA or Swiss">non-EU/EEA or Swiss</option>
                    <option value="EU">EU</option>
                </select>
                <span class="error-message">${rvo_obj.translations.error_nationality}</span>
            </div>
            <div class="input-group" id="email">
                <input class="input required" name="email" type="email" required="required" placeholder="Business Email *">
                <span class="error-message">${rvo_obj.translations.error_email}</span>
            </div>
            <div class="input-group">
                <input class="input linkedin-input" name="linkedin" type="url" pattern="https://.*" placeholder="LinkedIn">
                <svg data-name="Group 3" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 46.06 46.05"><g data-name="Group 2" fill="#ff6833"><path data-name="Path 13" d="M46.06 23.03v.03l-.15 9.66A13.329 13.329 0 0132.73 45.9l-9.7.15H23l-9.66-.15A13.329 13.329 0 01.16 32.72L0 23.03V23l.15-9.66A13.338 13.338 0 0113.33.15l9.7-.15h.03l9.66.15A13.329 13.329 0 0145.9 13.33zm-4.29 0l-.15-9.63a9.062 9.062 0 00-8.96-8.96l-9.63-.15-9.63.15a9.076 9.076 0 00-8.96 8.96l-.15 9.63.15 9.63a9.062 9.062 0 008.96 8.96l9.63.15 9.63-.15a9.062 9.062 0 008.96-8.96z"/><path data-name="Path 14" d="M34.4 15.53c1.55 1.58 1.53 3.92 1.5 6.63 0 .41-.01.85-.01 1.29v10.57a1.505 1.505 0 11-3.01 0V23.45c0-.46 0-.91.01-1.33.03-2.12.05-3.79-.63-4.47-.46-.47-1.46-.7-2.98-.7-1.86 0-4.18 1.75-5.01 2.89l-.02 13.63a1.51 1.51 0 01-3.02 0l.02-13.7a1.526 1.526 0 01-.03-.3V15.1a1.51 1.51 0 013.02 0v.69a.906.906 0 01.16-.11 8.978 8.978 0 014.88-1.73c2.42-.03 4.05.48 5.12 1.58z"/><path data-name="Path 15" d="M12.54 13.59a1.515 1.515 0 00-1.51 1.51v18.94a1.51 1.51 0 003.02 0V15.09a1.5 1.5 0 00-1.51-1.5z"/></g><path data-name="Path 16" d="M12.53 9.38a1.705 1.705 0 101.7 1.72v-.02a1.686 1.686 0 00-1.7-1.7z" fill="#ff6833"/></svg>
            </div>
            <div class="send-error">
                <span></span>
            </div>
            <div class="contact-submit">
                <button class="btn-primary submit-form" type="submit" id="submit_form">
                    ${rvo_obj.translations.text_send}
                </button>
                <div class="loader">
                    <svg xmlns="http://www.w3.org/2000/svg" width="50" height="30" viewBox="0 0 120 30" fill="#ff6833">
                        <circle cx="15" cy="15" r="9.32367">
                            <animate attributeName="r" from="15" to="15" begin="0s" dur="0.8s" values="15;9;15" calcMode="linear" repeatCount="indefinite"/>
                            <animate attributeName="fill-opacity" from="1" to="1" begin="0s" dur="0.8s" values="1;.5;1" calcMode="linear" repeatCount="indefinite"/>
                        </circle>
                        <circle cx="60" cy="15" r="14.6763" fill-opacity="0.3">
                            <animate attributeName="r" from="9" to="9" begin="0s" dur="0.8s" values="9;15;9" calcMode="linear" repeatCount="indefinite"/>
                            <animate attributeName="fill-opacity" from="0.5" to="0.5" begin="0s" dur="0.8s" values=".5;1;.5" calcMode="linear" repeatCount="indefinite"/>
                        </circle>
                        <circle cx="105" cy="15" r="9.32367">
                            <animate attributeName="r" from="15" to="15" begin="0s" dur="0.8s" values="15;9;15" calcMode="linear" repeatCount="indefinite"/>
                            <animate attributeName="fill-opacity" from="1" to="1" begin="0s" dur="0.8s" values="1;.5;1" calcMode="linear" repeatCount="indefinite"/>
                        </circle>
                    </svg>
                    <span>${rvo_obj.translations.text_loader}</span>
                </div>
            </div>
        </div>
    </div>
`;

const formTypeRadios = document.querySelectorAll('.form-type-radio');
const dynamicFormContent = document.querySelector('#dynamic_form_content');
let requiredFields = document.querySelectorAll('.required');
let checkboxesRequiredDOM = document.querySelectorAll('.checkbox_input');
let formHasCheckboxes = true;

const addSubmitListener = (submitButton, formHasCheckboxes, sendError, sendErrorMsg) => {
    submitButton.addEventListener('click', function(e) {
        e.preventDefault();
        let errorMsgDOM = '';
        let valid = true;

        if(!validateForm(requiredFields)){
            valid = false;
        }

        if(formHasCheckboxes) {
            errorMsgDOM = document.querySelector('.checkbox-error');
            if(!validateCheckboxes(checkboxesRequiredDOM, errorMsgDOM)) {
                valid = false;
            }
        }

        if(valid) {
            sendFormData('contact_form', sendError, sendErrorMsg);
        }
    });
};

const getRequiredFields = () => {
    checkboxesRequiredDOM = document.querySelectorAll('.checkbox_input');
    requiredFields = document.querySelectorAll('.required');
};

const addFileListener = (fileInput, customFileInput) => {
    const fileName = document.querySelector('.file-name');
    const deleteButton = document.querySelector('.delete_file');
    fileInput.addEventListener('change', (input) => {
        setFileValue(input.target, fileName, deleteButton);
    });
    customFileInput.addEventListener('click', function() {
        this.parentNode.querySelector('.file-input').click();
    });
    deleteButton.addEventListener('click', () => {
        fileInput.value = '';
        deleteButton.style.display = 'none';
        fileName.innerHTML = rvo_obj.translations.no_file;
    });
}

// Multi select function
const setMultiSelect = () => {
    const multiSelectDOM = document.querySelector('.sector-select');
    const selectedOptionsDOM = document.querySelector('.selected-options');
    const hiddenOptionsDOM = document.querySelector('#selected_options');
    let selectedOptionsArr = [];

    multiSelectDOM.addEventListener('change', function() {
        if(this.value === 'null' || this.value === '' || selectedOptionsArr.includes(this.value)) return;
        const selectedOptionTemplate = `
            <div class="selected-option">
                <span>${this.value}</span>
                <button type="button" class="delete-option" data-value="${this.value}">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33.234 33.234"><g fill="none" stroke="#fff" stroke-miterlimit="10" stroke-width="2"><path data-name="Line 4" d="M.707.707l31.82 31.82"/><path data-name="Line 5" d="M.707 32.527L32.527.707"/></g></svg>
                </button>
            </div>
        `;
        selectedOptionsDOM.innerHTML += selectedOptionTemplate;
        const deleteOptionNodes = document.querySelectorAll('.delete-option');

        // Add values to hidden options field
        selectedOptionsArr.push(this.value);
        hiddenOptionsDOM.value = selectedOptionsArr;

        // Remove option
        deleteOption(deleteOptionNodes, selectedOptionsArr, hiddenOptionsDOM);
    });
}

function limitSpecialChars(elem) {
    elem.addEventListener('input', function() {
        this.value = this.value.replace(/[`~#^|\<>\{\}\[\]\\\/]/gi, '');
    });
}

const hiddenFormTypeDOM = document.getElementById('form_type');
formTypeRadios.forEach(radio => {
    radio.addEventListener('change', () => {
        if(radio.value === 'FIND_JOB') {
            hiddenFormTypeDOM.value = radio.value;
            dynamicFormContent.innerHTML = jobForm;
            formHasCheckboxes = true;
            setMultiSelect();
            getRequiredFields();
            addSubmitListener(document.querySelector('#submit_form'), formHasCheckboxes, document.querySelector('.send-error'), document.querySelector('.send-error span'));
        }
        if(radio.value === 'START_BUSINESS') {
            hiddenFormTypeDOM.value = radio.value;
            dynamicFormContent.innerHTML = startBusinessForm;
            formHasCheckboxes = true;
            getRequiredFields();
            addFileListener(document.getElementById('file-input'), document.querySelector('.custom-file-input'));
            addSubmitListener(document.querySelector('#submit_form'), formHasCheckboxes, document.querySelector('.send-error'), document.querySelector('.send-error span'));
            const textArea = document.querySelector('textarea');
            limitSpecialChars(textArea);
        }
        if(radio.value === 'STUDYING') {
            dynamicFormContent.innerHTML = studyingForm;
        }
        if(radio.value === 'OTHER') {
            hiddenFormTypeDOM.value = radio.value;
            formHasCheckboxes = false;
            dynamicFormContent.innerHTML = otherForm;
            getRequiredFields();
            addSubmitListener(document.querySelector('#submit_form'), formHasCheckboxes, document.querySelector('.send-error'), document.querySelector('.send-error span'));
            const textArea = document.querySelector('textarea');
            limitSpecialChars(textArea);
        }
    });
});

const deleteOption = (optionNodes, selectedOptionsArr, hiddenOptionsDOM) => {
    optionNodes.forEach(node => {
        const nodeValue = node.getAttribute('data-value');
        const parentNode = node.parentNode;
        node.addEventListener('click', function() {
            const index = selectedOptionsArr.indexOf(nodeValue);
            if (index > -1) {
                selectedOptionsArr.splice(index, 1);
                parentNode.remove();
                hiddenOptionsDOM.value = selectedOptionsArr;
            }
        });
    });
};

const confirmationModal = document.querySelector('.contact-modal');

const validateForm = fields => {
    let valid = true;
    fields.forEach(field => {
        const errorMsg = field.parentNode.querySelector('.error-message');
        if(!field.value.trim()){
            valid = false;
            field.classList.add('form-error');
            errorMsg.style.display = 'block';
        } else{
            field.classList.remove('form-error');
            errorMsg.style.display = 'none';
        }
        if(field.type === 'email') {
            if(field.value.trim() !== '') {
                if(valid_email_address(field.value.trim())) {
                    field.classList.remove('form-error');
                    errorMsg.style.display = 'none';
                } else {
                    valid = false;
                    field.classList.add('form-error');
                    errorMsg.style.display = 'block';
                    errorMsg.innerHTML = rvo_obj.translations.invalid_email;
                }
            } else {
                valid = false;
                field.classList.add('form-error');
                errorMsg.style.display = 'block';
                errorMsg.innerHTML = rvo_obj.translations.no_email;
            }
        }
        if(field.type === 'file'){
            if(field.value === ''){
                errorMsg.innerHTML = rvo_obj.translations.no_file_error;
                errorMsg.style.display = 'block';
                valid = false;
            }
        }
    });
    return valid;
};

const validateCheckboxes = (checkboxInputs, errorMessage = '') => {
    let valid = true;
    let notSelected = [].filter.call(checkboxInputs, function( checkbox) {
        return !checkbox.checked;
    });
    if(checkboxInputs.length === notSelected.length) {
        valid = false;
        errorMessage.style.display = 'block';
    } else {
        errorMessage.style.display = 'none';
    }
    return valid;
};

const setFileValue = (el, el2, deleteButton) => {
    let text = el.value.match(/[\/\\]([\w\d\s\.\-\(\)]+)$/)[1];
    let fileType = text.split('.');
    const errorMessage = el.parentNode.querySelector('.error-message');
    if (fileType[fileType.length - 1] !== 'doc' && fileType[fileType.length - 1] !== 'docx' && fileType[fileType.length - 1] !== 'pdf' && fileType[fileType.length - 1] !== 'PDF') {
        el.value = '';
        errorMessage.innerHTML = rvo_obj.translations.file_not_allowed;
        errorMessage.style.display = 'block';
        el2.innerHTML = rvo_obj.translations.no_file;
        deleteButton.style.display = 'none';
    } else {
        let size = el.files[0].size;
        if (size > 2097152) {
            errorMessage.innerHTML = rvo_obj.translations.file_to_large;
            errorMessage.style.display = 'block';
            el.value = '';
            el2.innerHTML = rvo_obj.translations.no_file;
            deleteButton.style.display = 'none';
        } else {
            el2.innerHTML = text;
            errorMessage.style.display = 'none';
            deleteButton.style.display = 'block';
        }
    }
};

const valid_email_address = email => {
    let pattern = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    return pattern.test(email);
};

function sendFormData(formElementID, sendError, sendErrorMsg) {
    const submit = document.querySelector('#submit_form');
    submit.setAttribute('disabled', true);
    const XHR = new XMLHttpRequest();
    const form = document.getElementById(formElementID);
    const formData = new FormData(form);
    const fileInput = document.getElementById('file-input');
    XHR.responseType = 'json';
    if(fileInput) {
        const file = fileInput.files[0];
        formData.append("attach", file);
    }
    const loader = document.querySelector('.loader');
    loader.style.display = 'flex';

    XHR.onreadystatechange = function() {
        const {readyState, status, response, statusText} = XHR;
        if (readyState === 4) {
            const {data, success} = response;
            if(status === 200) {
                const message = response.data.message;
                if(success) {
                    grecaptcha.execute(rvo_obj.captcha, {action: 'quote_form'}).then(function(token) {
                        var captcha_field = document.querySelector('#captcha_token');
                        captcha_field.value = token;
                    });
                    form.reset();
                    submit.removeAttribute('disabled');
                    confirmationModal.classList.add('facilitators__modal--open');
                    loader.style.display = 'none';
                    const deleteButton = document.querySelector('.delete_file');
                    const fileName = document.querySelector('.file-name');
                    const selectedOptions = document.querySelector('.selected-options');
                    const hiddenOptions = document.querySelector('#selected_options');
                    if(selectedOptions) {
                        selectedOptions.innerHTML = '';
                        hiddenOptions.value = '';
                        setMultiSelect();
                    }
                    if(deleteButton) {
                        deleteButton.style.display = 'none';
                    }
                    if(fileName) {
                        fileName.innerHTML = rvo_obj.translations.no_file;
                    }
                } else {
                    sendErrorMsg.innerHTML = message;
                    sendError.style.display = 'flex';
                    submit.removeAttribute('disabled');
                    loader.style.display = 'none';
                }
            }
        }
    }
    XHR.open('POST', rvo_obj.ajax_url);
    XHR.send(formData);
}


